module.exports = __webpack_public_path__ + "static/media/plus.16380594.svg";